import Button from "../../components/Buttons/Button";
import CustomTooltip from "../../components/toolTipComponent/CustomTooltip";
import TableCustomAppliesToField from "../../components/table/TableCustomAppliesToField";
import TableCustomPriceRangeField from "../../components/table/TableCustomPriceRangeField";
import {
  EditIcon,
  DeleteIcon,
  ActionDotsIcons,
} from "../../../assets/icons/iconsProvider";
import {
  buttonNameConstants,
  buttonTypeConstants,
  SET_BY_TRADE_IN_MARGIN_OPTIONS,
  shopifyConstants,
} from "../../../constants";
import {
  CustomCellRendererWithSkeleton,
  TableCustomCellWrapper,
} from "../../components";
import { getActionColumnOfReactDataTableComponent } from "./generic";
import { getGroupArrayDisplayText } from "../tradeInMarginUtility";
import { truncate } from "../genericUtility";

//------- Column Headers For Shopify Presets
const getShopifyPresetsColumnHeaders = (handleDeleteClick, handleEditClick) => {
  return [
    {
      id: "setBy",
      name: "Set By",
      selector: (row) => row.type,
      cell: (row) => {
        return (
          <TableCustomCellWrapper
            cellValue={
              SET_BY_TRADE_IN_MARGIN_OPTIONS.find(
                (item) => item.value === row.type
              ).label
            }
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "appliesTo",
      name: "Applies To",
      selector: (row) => getGroupArrayDisplayText(row.group, row.type),
      cell: (row) => {
        return (
          <TableCustomAppliesToField
            row={row}
            groupArray={row.group}
            groupType={row.type}
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "priceRange",
      name: "Price Range",
      selector: (row) => row.maxPriceRange,
      cell: (row) => {
        return <TableCustomPriceRangeField row={row} />;
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: shopifyConstants.LINK_TO_SHOPIFY,
      name: buttonNameConstants.LINK_TO_SHOPIFY,
      selector: (row) => row?.[shopifyConstants.LINK_TO_SHOPIFY],
      cell: (row) => (
        <TableCustomCellWrapper
          cellValue={row?.[shopifyConstants.LINK_TO_SHOPIFY] ? "Yes" : "No"}
        />
      ),
      sortable: true,
      sortDirection: null,
    },
    {
      id: shopifyConstants.SEPERATE_QUANTITY,
      name: buttonNameConstants.SEPARATE_QUANTITY,
      selector: (row) => row?.[shopifyConstants.SEPERATE_QUANTITY],
      cell: (row) => (
        <TableCustomCellWrapper
          cellValue={row?.[shopifyConstants.SEPERATE_QUANTITY] ? "Yes" : "No"}
        />
      ),
      sortable: true,
      sortDirection: null,
    },
    getActionColumnOfReactDataTableComponent((row) => {
      return (
        <>
          <CustomTooltip anchorSelect={`#tool${row.id}`}>
            <Button
              label={buttonNameConstants.EDIT}
              className="w-100"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={EditIcon}
              handleClick={() => handleEditClick(row)}
            />
            <Button
              label={buttonNameConstants.DELETE}
              className="w-100"
              type="button"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={DeleteIcon}
              handleClick={() => handleDeleteClick(row.id)}
            />
          </CustomTooltip>
          <button id={`tool${row.id}`} className="action-Button-Wrapper">
            <ActionDotsIcons className="cursor-pointer" />
          </button>
        </>
      );
    }),
  ];
};

const shopifyResetStatusDetailViewColumnHeaders = () => {
  return [
    {
      id: "productName",
      name: "Product Name (Failed Shopify Sync)",
      selector: (row) => row.product_name,
      cell: (row) => {
        return <TableCustomCellWrapper cellValue={row.product_name} />;
      },
      sortable: false,
      sortDirection: null,
    },
    {
      id: "errorMessage",
      name: "Error Message",
      selector: (row) => String(row.errorMessage).slice(300),
      cell: (row) => {
        return (
          <CustomCellRendererWithSkeleton
            params={row}
            componentRenderCondition={true}
            cellComponent={truncate(row.errorMessage)}
            titleToolTipText={row.errorMessage}
          />
        );
      },
      sortable: false,
      sortDirection: null,
    },
    {
      id: "action",
      name: "",
      selector: (row) => row.product_name,
      width: "1px",
      cell: (row) => {
        return <></>;
      },
      sortable: false,
      sortDirection: null,
    },
  ];
};

export {
  getShopifyPresetsColumnHeaders,
  shopifyResetStatusDetailViewColumnHeaders,
};
